export * from './baAppPicture.pipe';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/pipes/baAppPicture/index.ts